/**
 * Single source of truth for Fit score coloring.
 *
 * Thresholds over the 0–100 range: ≥60 healthy (green), ≥40 middling (amber),
 * <40 weak (red). Used by the account-list sidebar and the pipeline sidebar so
 * the same fit score always renders the same color.
 *
 * Propensity score does NOT use this — it renders as a 🔥 flame scale via
 * lib/propensityFire.ts.
 */
export function getScoreColors(score: number): { bg: string; text: string } {
  if (score >= 60) return { bg: 'bg-matcha-100', text: 'text-matcha-700' };
  if (score >= 40) return { bg: 'bg-tangerine-100', text: 'text-tangerine-700' };
  return { bg: 'bg-pomegranate-100', text: 'text-pomegranate-700' };
}
